<template>
    <div class="er_main">
        <div class="mainbg">
            <div class="ml">
                <ul class="mlnav">
                    <li v-for="(item, index) in datalist" :key="index"
                        @mouseover="handleMouseOver(index)"
                        @mouseout="handleMouseOut(index)"
                        :class="{ 'navs': isActiveIndex === index }" >
                        <a  :class="{ 'hover': isActiveIndex === index }" @click="gotoHref(item.href)">{{item.title}}</a>
                    </li>
                </ul>
            </div>
            <div class="mr">
                <div class="bt2">
                    <strong>风险控制</strong>
                    <p>您的位置：<a @click="goto('/')"  style="cursor:pointer">首页</a> - <a >风险控制</a></p>
                </div>
                <div class="abnr1">
                    <div class="wb_lei"  v-for="(item, index) in datalist" :key="index" >
                       <p class="wb_tit">
                           <strong>{{item.title}}</strong>
                           <a :href="getHref(item)"><img src="@/assets/images/wb_more.gif" width="31" height="5" /></a>
                       </p>
                        <ul class="wb_lei_list">
                            <a :href="getHref(item)"><img :src="item.filedPic" width="172" height="103" /></a>
                            <li>·<a :href="getHref(item)">{{item.title}}</a></li>
                            <li style="padding:5px 13px 0;">
                                <div class="con">
                                    <div v-html="item.content" class="htmlContent" style="margin-top: -1px"></div>
                                </div>
                                <a :href="getHref(item)" style="color:#EA5503;">详细>></a>
                            </li>
                        </ul>
                    </div>

                    <div class="clear"></div>
                </div>
            </div>
            <div class="clear"></div>
        </div>

    </div>
</template>

<script>
    import commonFun from "@/util/common.js";
    export default {
        name: "IndexItem",
        props: {
            datalist: {
                type: Array,
                required: true
            },

        },
        data() {
            return {
                menuItems: [
                    {
                        label: '风险控制',
                        href:'risk',
                        menuClase:'nav1',
                    },
                    {
                        label: '资讯管理',
                        href:'Advisory.aspx',
                        menuClase:'nav2',
                    },
                    {
                        label: '资讯管理',
                        href:'Advisory.aspx',
                        menuClase:'nav3',
                    },
                    {
                        label: '资讯管理',
                        href:'Outsourcing_list.aspx',
                        menuClase:'nav4',
                    },
                    {
                        label: '关于我们',
                        href:'Advisory.aspx',
                        menuClase:'nav5',
                    },
                ],
                isActiveIndex: null, // 用于跟踪当前激活的菜单项索引
            }
        },
        mounted() {

        },
        methods: {
            handleMouseOver(index) {
                this.isActiveIndex = index;
            },
            handleMouseOut(index) {
                if (this.isActiveIndex === index) {
                    this.isActiveIndex = null;
                }
            },
            goto(url){
                this.$router.push(url);
            },
            getHref(item){
                let router = commonFun.getRouter('Risk',item.fieldCode,item.id);
                return router;
            },
            gotoHref(url){
                url = '/' + url;
                this.$router.push(url);
            },
        },
        watch: {
            datalist: {
                handler(newVal, oldVal) {
                    this.menuItems = newVal.map(item=>{
                        item.href  = item.fieldCode;
                        return item;
                    });
                },
                immediate: true
            },
        }
    }
</script>

<style lang="scss" scoped >
    *{ margin:0; padding:0;}
    .body{ color:#666; font:12px "宋体";background:#daecec;}
    .er_main{width:968px;background:url("../../../assets/images/bg_left.jpg") repeat-y left top;margin:0 auto;}
    .mainbg{height:auto!important;min-height:256px;height:256px;background:url("../../../assets/images/bg_neiye.jpg") no-repeat left bottom;}
    .ml{height:auto !important;min-height:200px;height:200px;padding:5px 3px 0px 0px;width:213px;float:left;background:url("../../../assets/images/bg_touyin.jpg") no-repeat left top;}
    .mlnav{height:auto!Important;height:50px;min-height:50px;padding:9px 5px 33px 13px;width:200px;}
    .mlnav li{cursor: pointer; line-height:35px;padding-left:10px;background:url("../../../assets/images/bg_left1.jpg") no-repeat left bottom;height:auto!Important;height:35px;min-height:35px;}
    .mlnav li a{padding:0 0 0 15px;	background:url("../../../assets/images/list1.jpg") no-repeat left 2px;color:#666;line-height:35px;}
    .mlnav li a:hover,.mlnav li a.hover{color:#006765;text-decoration:none;background:url("../../../assets/images/list2.jpg") no-repeat left 2px;}
    .malepu{width:213px;height:auto !important;min-height:67px;height:67px;text-align:center;padding-bottom:20px; display:none;}
    .malepu img{border:0;}
    .mr{width:747px;height:auto!important;height:400px;min-height:400px;float:left;/*padding:0 20px 0 20px;*/position:relative;}
    .bt2{height:35px;border-bottom:1px solid #dbdbdb;padding-left:13px;position:relative;}
    .bt2 strong{font-size:14px;color:#036d6a;background:url("../../../assets/images/dot_2.jpg") no-repeat left 14px;width:500px;display:block;padding-left:14px;/*line-height:35px;*/padding-top:12px;}
    .bt2 p{position:absolute;right:4px;top:14px;color:#666;}
    .bt2 p a{color:#666;}
    .bt2 p a:hover{color:#036d6a;text-decoration:none;}
    .abnr{line-height:24px;padding:20px;height:auto!Important;height:200px;min-height:200px;}
    .clear {clear: both;height: 0;overflow: hidden;}
    a {
        color: #666;
        text-decoration: none;
        blr: expression(this.onFocus=this.blur());
        outline: none;
    }
    .adv_gd{ height:auto!Important; height:205px; min-height:205px; margin:0 auto;padding:10px 0 20px; margin:0 10px;}
    .adv_gd img{float:left;}
    .adv_lei{width:300px;height:190px;background:url("../../../assets/images/gl_08.jpg") no-repeat left center;float:left;padding-top:15px;}
    .adv_lei li{width:198px;height:30px;padding-bottom:20px;padding-left:88px;}
    .adv_lei li a{width:198px;height:30px;display:block;}
    .adv1{background:url("../../../assets/images/gl_1.jpg") no-repeat left top;}
    .adv2{background:url("../../../assets/images/gl_2.jpg") no-repeat left top;}
    .adv3{background:url("../../../assets/images/gl_3.jpg") no-repeat left top;}
    .adv4{background:url("../../../assets/images/gl_4.jpg") no-repeat left top;}
    .adv_lei li a:hover{background-position:left bottom;}
    .new_list{width:678px;height:auto !important;	min-height:10px;height:100px;padding-bottom:15px;margin:0 auto;}
    .new_list li{width:678px;height:30px;border-bottom:#e5e5e5 1px solid;line-height:30px; position:relative;}
    .new_list li a{text-decoration:none;}
    .new_list li span{ position:absolute; right:0; top:0;}
    .new_con{width:678px;height:auto !important;min-height:200px;height:200px;line-height:25px;margin:0 auto;padding-bottom:10px;}
    .new_tit{font-size:16px;text-align:center;border-bottom:1px solid #dbdbdb;line-height:58px;margin-bottom:25px;}
    .title01{font-size:16px;text-align:center;border-bottom:1px solid #dbdbdb;line-height:58px;}
    .datebt{ height:25px; line-height:25px; margin-bottom:20px; text-align:center; color:#666; font-size:12px; border-bottom:1px solid #dbdbdb;}
    /**risk-index**/
    .abnr1{line-height:24px;padding-top:20px;padding-bottom:20px;height:auto!Important;height:200px;min-height:200px;}
    .wb_lei{width:729px;height:172px;margin:0 auto;background:url("../../../assets/images/wb_bg.gif") no-repeat left top;padding-bottom:14px;}
    .wb_tit{font-size:14px;height:31px;padding-left:14px;line-height:31px;position:relative;}
    .wb_tit a img{position:absolute;top:14px; right:14px;}
    .wb_lei_list {margin:12px 10px 10px 13px;}
    .wb_lei_list img{float:left;width:173px;height:103px;padding:6px;border:1px solid #ccc;background:#eee;margin-right:14px;}
    .wb_lei_list li{ height:auto!Important; height:20px; min-height:20px; line-height:20px;/*padding-left:14px;*/}
    .wb_lei_list li a:hover{text-decoration:none;}
    .con{
        width: 480px;
        resize: none;
        display: flex;
        position: relative;
        overflow: hidden;
        text-align: justify;
    }
    .htmlContent{
        line-height: 2.0;
        overflow: hidden;
        max-height: 6.0em;
    }
    .htmlContent::before{
        content: '...';
        float: right;
        /* background-color: red; */
        height: 100%;
        display: flex;
        align-items: flex-end;
        shape-outside: inset(calc(100% - 1.2em) 0 0 0);
        margin-left: 2px;
    }

    .htmlContent::after{
        content: '';
        position: absolute;
        width: 999vh;
        height: 999vh;
        background: aliceblue;
        box-shadow: -2em 2em aliceblue;
        pointer-events: none;
    }
    .txt-els{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }

    /**富文本内容-为了兼容safari**/
    /*
    .htmlContent{
        margin-top: -10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;  // 超过3行则显示省略号
        word-break: break-all;
    }

     */

</style>
